<template>
  <div>
    <div v-for="status in sortedStatuses" :key="status">
      <QuoteGroup
        v-if="groups[status]"
        :status="status"
        :quotes="groups[status]"
        class="quote-group"
        @quote-card-click="quoteCardClick"
      >
        <template #content="{ quote }">
          <slot name="group-card-content" :quote="quote" />
        </template>
      </QuoteGroup>
    </div>
  </div>
</template>

<script>
import { QUOTE_ACTION_DISPATCH } from "serviceshift-ui/components/MultipleQuotes/quoteActionDispatch";
import QuoteGroup from "serviceshift-ui/components/MultipleQuotes/QuoteGroup.vue";

export default {
  name: "QuoteGroupsList",
  components: {
    QuoteGroup
  },
  // Hand descendants a dispatcher instead of letting them reach this list over
  // the global EventBus. Every mounted list used to answer every bus emit, so a
  // single click fired one request per mounted list (TOF-696). Provide/inject
  // resolves through the component tree, so a menu can only ever reach the list
  // it actually belongs to, however many other lists are still mounted.
  provide() {
    return {
      [QUOTE_ACTION_DISPATCH]: this.dispatchQuoteAction
    };
  },
  props: {
    quotes: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    "quote-approve-click",
    "quote-force-approve-click",
    "schedule-work-click",
    "clone-quote-click",
    "decline-quote-click",
    "draft-quote-click",
    "pending-quote-click",
    "email-quote-click",
    "archive-quote-click",
    "unarchive-quote-click",
    "reactivate-quote-click",
    "pdf-quote-click",
    // Declared so the listeners QuotesTab binds for them resolve as component
    // events rather than falling through to the root div as DOM attributes.
    // `unapprove` was previously misspelled here ("unnaprove"), which left the
    // real event undeclared; the emit itself has always used this spelling.
    "unapprove-quote-click",
    "edit-quote-click",
    "quote-card-click"
  ],
  data() {
    return {
      sortedStatuses: [
        "approved",
        "pending",
        "open",
        "draft",
        "denied",
        "voided",
        "archived"
      ]
    };
  },
  computed: {
    groups() {
      // Splits quotes by status
      return this.quotes.reduce((groups, quote) => {
        if (groups[quote.status]) {
          groups[quote.status].push(quote);
        } else {
          // eslint-disable-next-line no-param-reassign
          groups[quote.status] = [quote];
        }
        return groups;
      }, {});
    }
  },
  methods: {
    // The action menus name the event they want; this list just re-emits it to
    // its own parent. Kept as a passthrough so adding an action needs no change
    // here beyond declaring it in `emits`.
    dispatchQuoteAction(eventName, payload) {
      this.$emit(eventName, payload);
    },
    quoteCardClick(quoteId) {
      this.$emit("quote-card-click", quoteId);
    }
  }
};
</script>

<style lang="scss" scoped>
.quote-group {
  margin-bottom: 25px;
}
</style>
